import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ProductLabel from 'apps/products/models/ProductLabel';

import ShowAlternativesButton from './ShowAlternativesButton';
import QuantityInputWithAddToBasket from 'apps/quantityControls/containers/QuantityInputWithAddToBasket';
import SellingGroupOptionsButton from './SellingGroupOptionsButton';
import { isNotSellingGroup } from 'apps/products/utils/skuType';

function isOutOfStock(product) {
  return (product.labels || []).includes(ProductLabel.OOS);
}

function hasAlternatives(product) {
  return product.hasAlternatives;
}

export default class RegularFopControls extends PureComponent {
  static propTypes = {
    analyticsFopContextDataBasketItems: PropTypes.any, // eslint-disable-line react/no-unused-prop-types
    analyticsFopContextDataContainerType: PropTypes.any, // eslint-disable-line react/no-unused-prop-types
    analyticsFopContextDataLocationQuery: PropTypes.any, // eslint-disable-line react/no-unused-prop-types
    analyticsFopContextDataExternalAd: PropTypes.any, // eslint-disable-line react/no-unused-prop-types
    basketQuantity: PropTypes.number.isRequired,
    location: PropTypes.object,
    collectionFopIdx: PropTypes.number,
    onQuantitySubmit: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    productWarning: PropTypes.bool.isRequired,
  };

  state = {
    analyticsContextData: {},
  };

  static getDerivedStateFromProps(props, state) {
    const {
      analyticsFopContextDataBasketItems: basketItems,
      analyticsFopContextDataContainerType: containerType,
      analyticsFopContextDataLocationQuery: productsPageRouteLocationQuery,
      analyticsFopContextDataExternalAd: externalAdData,
      location: section,
      collectionFopIdx,
      product,
    } = props;

    if (
      basketItems !== state.analyticsContextData.basketItems
      || product !== state.analyticsContextData.product
      || section !== state.analyticsContextData.section
      || productsPageRouteLocationQuery !== state.analyticsContextData.productsPageRouteLocationQuery
      || containerType !== state.analyticsContextData.containerType
      || externalAdData !== state.analyticsContextData.externalAdData
    ) {
      return {
        analyticsContextData: {
          basketItems,
          product,
          section,
          collectionFopIdx,
          productsPageRouteLocationQuery,
          containerType,
          externalAdData,
        },
      };
    }

    return null;
  }

  renderQuantityInputWithAddToBasket() {
    const { product, productWarning, onQuantitySubmit, location } = this.props;

    return (
      <div className="fop-add-default">
        <QuantityInputWithAddToBasket
          sku={product.sku}
          onQuantitySubmit={onQuantitySubmit}
          productWarning={productWarning}
          analyticsContextData={this.state.analyticsContextData}
          location={location}
        />
      </div>
    );
  }

  renderShowAlternativesButton() {
    const { product } = this.props;

    return (
      <ShowAlternativesButton product={product} />
    );
  }

  renderSellingGroupOptionsButton() {
    const { product, basketQuantity } = this.props;

    return (
      <SellingGroupOptionsButton
        product={product}
        basketQuantity={basketQuantity}
      />
    );
  }

  render() {
    const { product } = this.props;

    if (!product) {
      return null;
    }

    if (isOutOfStock(product)) {
      return hasAlternatives(product) ? this.renderShowAlternativesButton() : null;
    }

    if (isNotSellingGroup(product)) {
      return this.renderQuantityInputWithAddToBasket();
    }

    return this.renderSellingGroupOptionsButton();
  }
}
